var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1818_3084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.16675H2C1.46957 1.16675 0.960859 1.37746 0.585786 1.75253C0.210714 2.12761 0 2.63631 0 3.16675L0 15.8334H16V3.16675C16 2.63631 15.7893 2.12761 15.4142 1.75253C15.0391 1.37746 14.5304 1.16675 14 1.16675ZM2 2.50008H14C14.1768 2.50008 14.3464 2.57032 14.4714 2.69534C14.5964 2.82037 14.6667 2.98994 14.6667 3.16675V3.61141L9.41467 8.86408C9.03895 9.23829 8.53028 9.44839 8 9.44839C7.46972 9.44839 6.96105 9.23829 6.58533 8.86408L1.33333 3.61141V3.16675C1.33333 2.98994 1.40357 2.82037 1.5286 2.69534C1.65362 2.57032 1.82319 2.50008 2 2.50008ZM1.33333 14.5001V5.50008L5.64267 9.80675C6.26842 10.4309 7.11617 10.7814 8 10.7814C8.88383 10.7814 9.73158 10.4309 10.3573 9.80675L14.6667 5.50008V14.5001H1.33333Z",
    fill: "#005C8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1818_3084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailTeam);
export default __webpack_public_path__ + "static/media/email-team.b9240597b12abd54925ab212a26016cf.svg";
export { ForwardRef as ReactComponent };